import * as types from "../actions";
const initialState = {
  statusList: [],
};

export default function pbhDashboard(state = initialState, action) {
  const response = action.payload;

  switch (action.type) {
    case types.PBH_DASHBOARD_MODEL_CHANGED:
      return { ...state, ...response };
    case types.PBH_REQUEST_MODEL_CLEAR:
      return { ...state, statusList: [] };
    default:
      return state;
  }
}
